import { createAsyncThunk } from "@reduxjs/toolkit";
import { upload_identity } from "../../../networking/urlEndPoints";
import Axios from "../../../networking/interceptor";

export const uploadImage = createAsyncThunk('uploadImage', async (requestedData, { rejectWithValue }) => {
 
    try {
        const response = await Axios.post(upload_identity, requestedData)
       
        const data = response.data
        return data;
    

    } catch (error) {
        return rejectWithValue(error.response)
    }
});